const LEGACY_HTTP_API_URL = "http://node02.nl.onthepixel.net:25569";
const HTTPS_API_URL = "https://wss.intern.jape-dev.de";
const WSS_URL = "wss://wss.intern.jape-dev.de";
const LIST_FRONTEND_URL = "https://liste.schule.projects.jape-dev.de";

function normalizeApiUrl(url) {
  const cleanUrl = (url || HTTPS_API_URL).replace(/\/+$/, "");

  if (cleanUrl === LEGACY_HTTP_API_URL) return HTTPS_API_URL;
  return cleanUrl;
}

function normalizeWsUrl(url) {
  const cleanUrl = (url || WSS_URL).replace(/\/+$/, "");

  if (cleanUrl === LEGACY_HTTP_API_URL) return WSS_URL;
  if (cleanUrl === HTTPS_API_URL) return WSS_URL;
  return cleanUrl;
}

export const API_URL = normalizeApiUrl(process.env.REACT_APP_API_URL);
export const WS_URL = normalizeWsUrl(process.env.REACT_APP_WS_URL);
export const FRONTEND_URL = (process.env.REACT_APP_FRONTEND_URL || LIST_FRONTEND_URL).replace(/\/+$/, "");
